'use strict';

var settingsData = require('../config/grid-settings.json');
var GridBasicExampleController = function GridBasicExampleController($scope) {
  $scope.settings = settingsData;
};
GridBasicExampleController.$inject = ['$scope'];
module.exports = GridBasicExampleController;